/* eslint-disable jsx-a11y/anchor-has-content */
import React from "react";

import { InstitutionSettingsContextProvider } from "../contexts/InstitutionSettingsContext";
import CardOffersDashboard from "./CardOffersDashboard";

/**
 * CardOffersDashboardManager - Wrapper component for CardOffersDashboard
 *
 * This wrapper provides the InstitutionSettingsContextProvider around the CardOffersDashboard
 * component, ensuring that institution settings are available throughout the dashboard.
 *
 * @param features - API feature flags to control component behavior
 */
const CardOffersDashboardManager = () => (
  <InstitutionSettingsContextProvider>
    <CardOffersDashboard />
  </InstitutionSettingsContextProvider>
);

export default CardOffersDashboardManager;
